import React, { useContext, useEffect, useCallback, useRef } from 'react';
import RegisterCard from 'components/RegisterCard/RegisterCard';
import UserContext from 'pages/Login/UserContext';
import getHourAndDate from 'utils/getHourAndDate';
import './CreateAccountStepItem.scss';
import { useTranslation } from 'react-i18next';
import LogoCatbears from 'components/LogoCatbears/LogoCatbears';
import ButtonCircle from 'components/ButtonCircle/ButtonCircle';
// useEffect already imported from React at top

const CreateAccountStepItem = ({
  onContinue,
  onBack,
  addEvent,
  stepItemId,
  CurrentSelectedStepItem,
  isSkippable = false,
}) => {
  const { user } = useContext(UserContext);
  const { t } = useTranslation();
  const completeAndAdvance = useCallback(() => {
    addEvent && addEvent('continue', 'stepItem', 'CreateAccountStepItem', CurrentSelectedStepItem, stepItemId, getHourAndDate());
    onContinue && onContinue();
  }, [addEvent, onContinue, CurrentSelectedStepItem, stepItemId]);

  const didCompleteRef = useRef(false);

  useEffect(() => {
    if (user && !user.isGuest && !didCompleteRef.current) {
      // If already logged in, auto-complete this item once
      didCompleteRef.current = true;
      completeAndAdvance();
    }
  }, [user?.isGuest]);

  useEffect(() => {
    try { document.body.classList.add('hide-global-notification'); } catch(_) {}
    return () => { try { document.body.classList.remove('hide-global-notification'); } catch(_) {} };
  }, []);

  if (!user || !user.isGuest) return null;

  return (
    <>
      <div className={'Onboarding-container CreateAccountStepItem '}>
        <div className={'CreateAccountStepItem__back'}>
          <ButtonCircle classes={'ButtonCircle-back ButtonCircle-50px'} onClick={() => onBack && onBack()} />
        </div>
        <div className={'Onboarding-content Onboarding-container-no-footer'}>
          <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', marginBottom: 16}}>
            <LogoCatbears isSoundSwitch={false} isFeedbackBtn={false} hideLogoOnMobile={false} isCentered={false} isTapToLandingPage={false} isFixed={false} />
            <div className="Onboarding-title">{t('loginFlow.createAnAccount')}</div>
            <div className="Onboarding-subtitle">{t('loginFlow.progress-saved')}</div>
          </div>
          <RegisterCard
            isTitleInsideBox={true}
            onSuccess={completeAndAdvance}
          />
        </div>
      </div>
    </>
  );
};

export default CreateAccountStepItem;


